angular
    .module("skillBuilderSaaS")
    .filter("duration", function () {
    var DURATION_FORMATS_SPLIT = /((?:[^yMdhm']+)|(?:'(?:[^']|'')*')|(?:y|M|d|h|m))(.*)/;
    var DURATION_FORMATS = {
        y: { single: "{{ 'common.year' | translate }}", plural: "{{ 'common.years' | translate }}" },
        M: { single: "{{ 'common.month' | translate }}", plural: "{{ 'common.months' | translate }}" },
        d: { single: "{{ 'common.day' | translate }}", plural: "{{ 'common.days' | translate }}" },
        h: { single: "{{ 'common.hour' | translate }}", plural: "{{ 'common.hours' | translate }}" },
        m: { single: "{{ 'common.minute' | translate }}", plural: "{{ 'common.minutes' | translate }}" }
    };
    function _parseFormat(string) {
        var parts = [];
        var format = string ? string.toString() : "";
        while (format) {
            var match = DURATION_FORMATS_SPLIT.exec(format);
            if (match) {
                parts = parts.concat(match.slice(1));
                format = parts.pop();
            }
            else {
                parts.push(format);
                format = null;
            }
        }
        return parts;
    }
    function _formatDuration(inputs, formats) {
        var result = "";
        formats.forEach(function (part) {
            var format = DURATION_FORMATS[part];
            var input = parseFloat(inputs.shift());
            if (format && input > 0) {
                if (result !== "")
                    result += ", ";
                if (input > 1)
                    result += input + " " + format.plural;
                else
                    result += input + " " + format.single;
            }
        });
        return result;
    }
    return function (input, format) {
        var formats = _parseFormat(format);
        var inputs = input.split(":");
        if (inputs.length !== formats.length)
            return "input and format do not match.";
        else
            return _formatDuration(inputs, formats);
    };
});
